"use client"

import { useEffect, useState } from "react"
import { useRouter } from 'next/navigation'
import { useDispatch, useSelector } from "react-redux"
import { showAlert, selectLanguage, loginUser, setAccessToken, selectEmailsStopped } from "@/app/redux/store"

import { zodResolver } from "@hookform/resolvers/zod"
import * as z from "zod"
import { useForm } from "react-hook-form"
import { Loader2 } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  Form, FormControl, FormDescription, FormField, FormItem,
} from "@/components/ui/form"
import RegularInput from "../../admin/form-components/regularInput"
import { createUserFromWeb, getLabels, login, sendMailchimp, createUserMailchimp } from "@/app/adapters/api"
import ContentContainer from "../../web/content-container/contentContainer"
import Label from "../../web/label/Label"
import RegularSelect from "../../admin/form-components/regularSelect"
import { Checkbox } from "@/components/ui/checkbox"
import Link from "next/link"
type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[]
}

declare const window: WindowWithDataLayer

const formSchema = z.object({
  name: z.string().min(1, {
    message: 'Campo obligatorio'
  }),
  surname: z.string().min(1, {
    message: 'Campo obligatorio'
  }),
  preference: z.string().min(1, {
    message: 'Campo obligatorio'
  }),
  email: z.string().min(1, {
    message: 'Campo obligatorio'
  }),
  password: z.string().min(1, {
    message: 'Campo obligatorio'
  }),
  repeatPassword: z.string().min(1, {
    message: 'Campo obligatorio'
  }),
  legal: z.boolean()
})

const labelsNames = [
  "switch-signup",
  "textLogin",
  "titleLogin",
  "join",
  "agreement-register-last",
  "go-to-entrepeneur",
  "register-values",
  "register-btn",
  "entrepreneur-login",
]

const authBackgroundURL = `/images/register-bg.png`

export default function WideSignup(props:{lang: string}) {

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: "",
      surname: "",
      preference: "",
      email: "",
      password: "",
      repeatPassword: "",
      legal: false,
    },
  })

  const dispatch = useDispatch()
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const [labels, setLabels] = useState<any>({})
  
  const lang = props.lang

  useEffect(() => {
    getLabels(labelsNames)
      .then((response) => {
        setLabels(response.data.labels)
      })
      .finally(() => {
      });
  }, [])



  const onSubmit = (values: z.infer<typeof formSchema>) => {
    setLoading(true)
    let body = {
      ...values,
      dateRegister: new Date()
    }
    createUserFromWeb(body)
      .then((response) => {
        // login logic
        // dispatch(loginUser({
        //   id: response.data.user.id,
        //   name: response.data.user.name,
        //   surname: response.data.user.surname,
        //   role: response.data.user.role,
        //   isEnterprise: response.data.user.isEnterprise,
        //   userMangoId: response.data.user.userMangoId || '',
        //   walletId: response.data.user.walletId || '',
        //   bankAccountId: response.data.user.bankAccountId || '',
        //   isLogin: true,
        // }))
        // dispatch(setAccessToken(response.data.accessToken))
        window.dataLayer.push({ event: 'registro', tipologia: body.preference })
        const message = lang === 'es' ? 'Bienvenid@' : 'Welcome'
        dispatch(showAlert({
          text: message,
          type: 'success',
          isShow: true
        }))
        router.push(`/bienvenida/`)
        createUserMailchimp(values.email);
        sendMailchimpSignUp(values.email, values.name);
      })
      .finally(() => {
        setLoading(false)
      })
  }

  function sendMailchimpSignUp(email: string, name: string) {
    let templateName = '';
    let subject = ''
    if (lang === 'es') {
      templateName = "copia-es-es-register"
      subject = '¡Bienvenido a Bolsa Social, la plataforma de inversión de impacto social!'
    } else {
      templateName = "en-us-register"
      subject = 'Welcome to Bolsa Social - Your Registration is Complete!'
    }
    const data = {
      params: {
        to: [{ email }],
        templateName: templateName,
        subject: subject,
        from: "contacto@bolsasocial.com",
        vars: [{ name: "name", content: name }]
      }
    }
    sendMailchimp(data);
  }

  return (
    <div className="flex flex-col-reverse md:flex-row md:max-w-[1200px] h-auto md:min-h-[600px] mx-auto my-10 px-6">
      <div className="w-full md:w-[100%] h-auto md:min-h-[600px] flex flex-col md:flex-row justify-end rounded-[90px] z-10" style={{ backgroundImage: `url(${authBackgroundURL})`, backgroundSize: 'cover' }}>
        <div className="md:w-[85%] w-[100%] md:h-[100%] z-40 flex justify-center items-center rounded-[90px] bg-[#3a3e45e3] px-8 py-2">
          <p className="text-white md:text-3xl text-2xl font-bold text-center px-10">Bolsa Social forma parte de Goparity. Los nuevos registros están cerrados. <a href="https://www.goparity.com/es" target="_blank" rel="noopener noreferrer" className="underline hover:opacity-80">Descubre más sobre Goparity →</a></p>
          {/* <div className="md:w-[55%] w-[100%] h-[90%] md:h-[100%] flex flex-col items-center md:px-10 px-4">
            <p className="my-8 text-white md:text-5xl text-3xl font-bold"><Label label={labels.join} lang={lang} /></p>
            <p className="my-4 px-3 text-white text-2xl font-regular text-center"><Label label={labels.registerValues} lang={lang} /></p>
            <a href='/oportunidades-inversion'>
              <Button className="mt-2 px-8 py-3 w-[280px] h-[60px] rounded-full text-sm font-semibold shadow-lg">
                <Label label={labels.registerBtn} lang={lang} />
              </Button>
            </a>
          </div>
          <div className="md:w-[45%] w-[100%] h-[100%] rounded-[40px] px-6 md:px-6 py-2 text-white text-sm font-normal">
            <Form {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)} >
                <RegularInput
                  name="name"
                  label={lang == 'es' ? "Nombre completo" : "Full name"}
                  extraClass="bg-white border-primary rounded-full h-[34px] text-black"
                  form={form}
                  isEditable={true} />
                <RegularInput
                  name="surname"
                  label={lang == 'es' ? "Primer y segundo apellido" : "Surname"}
                  extraClass="bg-white border-primary rounded-full h-[34px] text-black"
                  form={form}
                  isEditable={true} />
                <RegularSelect
                  name="preference"
                  label={lang == 'es' ? "Me interesa" : "Interested in"}
                  extraClass="bg-white border-primary rounded-full h-[34px] text-black"
                  form={form}
                  items={lang == 'es' ?
                    [
                      { value: "lending", label: "Prestamos sostenibles" },
                      { value: "equity", label: "Inversión en capital" },
                      { value: "both", label: "Ambas opciones" },
                    ]
                    :
                    [
                      { value: "lending", label: "Lending" },
                      { value: "equity", label: "Equity" },
                      { value: "both", label: "Both options" },
                    ]
                  }
                />
                <RegularInput
                  name="email"
                  label="Email"
                  extraClass="bg-white border-primary rounded-full h-[34px] text-black"
                  form={form}
                  isEditable={true} />
                {
                  !validateEmail(form.watch('email'))
                    ?
                    <p className="text-center text-[11px] text-red-500">{lang === 'es' ? 'Email incorrecto' : 'Wrong email'}</p>
                    :
                    null
                }
                <RegularInput
                  name="password"
                  label={lang == 'es' ? "Contraseña" : "Password"}
                  extraClass="bg-white border-primary rounded-full h-[34px] text-black"
                  form={form}
                  isEditable={true}
                  type={"password"} />
                {
                  !validatePassword(form.watch('password'))
                    ?
                    <p className="text-center text-[11px] text-red-500">{lang === 'es' ? 'La contraseña debe tener más de 6 caracteres, al menos una mayúscula, al menos una minúscula y al menos un número' : 'The password must be more than 6 characters, at least one uppercase letter, at least one lowercase letter, and at least one number'}</p>
                    :
                    null
                }
                <RegularInput
                  name="repeatPassword"
                  label={lang == 'es' ? "Repite contraseña" : "Repeat password"}
                  extraClass="bg-white border-primary rounded-full h-[34px] text-black"
                  form={form}
                  isEditable={true}
                  type={"password"} />
                {
                  form.watch('repeatPassword').length > 0 && form.watch('password') !== form.watch('repeatPassword')
                    ?
                    <p className="mt-1 text-center text-sm text-red-500">{lang === 'es' ? 'Las contraseña no son iguales' : 'Passwords are not equal'}</p>
                    :
                    null
                }
                <FormField
                  control={form.control}
                  name="legal"
                  render={({ field }) => (
                    <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md p-2">
                      <FormControl>
                        <Checkbox
                          checked={field.value}
                          onCheckedChange={field.onChange}
                        />
                      </FormControl>
                      <div className="space-y-1 leading-none text-[10px]">
                        <FormDescription>
                          <p className="text-[12px]">
                            <ContentContainer label={labels.agreementRegisterLast} lang={lang} />
                          </p>
                        </FormDescription>
                      </div>
                    </FormItem>
                  )}
                />
                <div className="flex flex-col md:flex-row justify-center md:justify-start items-center mt-2 mb-2 gap-4">
                  <Button type="submit"
                    variant={"orange"}
                    className="mt-1 sm:mt-0 uppercase px-5 py-2 h-11 leading-4"
                    disabled={loading || !validateEmail(form.watch('email')) || !validatePassword(form.watch('password')) || form.watch('password') !== form.watch('repeatPassword') || !form.watch('legal')}>
                    {loading ? <><Loader2 className="mr-2 h-4 w-4" /> {lang == 'es' ? "Espere..." : "Wait..."} </> : <><p className="text-[12px]"><Label label={labels.join} lang={lang} /></p> </>}
                  </Button>
                  <div>
                    <p><ContentContainer label={labels.switchSignup} lang={lang} /></p>
                    <p><ContentContainer label={labels.entrepreneurLogin} lang={lang} /></p>
                  </div>
                </div>
              </form>
            </Form>
          </div> */}
        </div>
      </div>
    </div>
  )
}

const validatePassword = (password: string) => {
  if (password.length < 6) {
    return false;
  }
  if (!/[A-Z]/.test(password)) {
    return false;
  }
  if (!/[a-z]/.test(password)) {
    return false;
  }
  if (!/\d/.test(password)) {
    return false;
  }
  return true;
}

const validateEmail = (email: string) => {
  if (!/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(email)) {
    return false;
  }

  const domain = email.split('@')[1];
  if (domain === 'yopmail.com' || domain === 'maildrop.cc') {
    return false;
  }

  return true;
}